const vitalItemTypes = {
  new: "new",
  view: "view",
  edit: "edit",
};

export default vitalItemTypes;
